<!--
 * @Author: lbh
 * @Date: 2021-03-25 14:55:37
 * @LastEditors: lbh
 * @LastEditTime: 2021-10-12 09:48:56
 * @Description: file content
-->
<template>
  <div class="self_content self_c">
    <headNav
      color="#56AC9A"
      :back="true"
      :title="window_c['Map']"
    />
    <div
      class="self_body self_b"
      :style="'min-height:' + window_.self_body_h + 'px;'"
    >
      <div id="allmap">
        <GmapMap
          :center="{ lat: mapX, lng: mapY }"
          :zoom="17"
          map-type-id="roadmap"
          style="width: 100%;"
          :style="'height:' + window_.self_body_h + 'px;'"
        >
          <GmapMarker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            :clickable="true"
            :draggable="true"
            @click="center = m.position"
          />
        </GmapMap>
      </div>
    </div>
  </div>
</template>

<script>
import headNav from "@/components/headNav";
import VConsole from "vconsole";
import lang_ from "@/js/locales";
import util from "@/js/util";
export default {
  data () {
    return {
      window_c: {
        Map: "查看地圖"
      },
      window_: {
        self_body_h: 0
      },
      mapX: 0,
      mapY: 0,
      markers: [
        {
          position: {
            lat: 0,
            lng: 0
          }
        }
      ]
    };
  },
  created () {
    util.selfSetIcon(); // 設置logo
    util.getBrand(this);
    this.init_window();
    // this.init_lang();
  },
  mounted () { },
  methods: {
    init_window () {
      var self = this;
      let J = util.getWindowInner(),
        w = J.w,
        h = J.h;
      self.window_.self_body_h = h - 46;
      var maps = util
        .getQueryParams(this.$route.params)
        .slice(1)
        .join("_");
      var m = maps.split("_^");
      this.mapX = parseFloat(m[0]);
      this.mapY = parseFloat(m[1]);
      this.window_c["Map"] = decodeURIComponent(m[2]);
      if (m[3] == "con") {
        new VConsole();
      }
      this.markers[0].position.lat = parseFloat(m[0]);
      this.markers[0].position.lng = parseFloat(m[1]);
      // console.log(typeof (this.mapX));
      // console.log(this.mapY);
    },
    init_lang () {
      var window_c = this.window_c;
      window_c["Map"] = lang_.t("View map");
    }
  },
  components: {
    headNav
  }
};
</script>

<style>
.self_content {
  padding-top: 46px;
}
</style>



// WEBPACK FOOTER //
// src/view/brand/map.vue